<template>
	<div class="home_subscribe_item bg-white">
		<div class="content">
			<span class="label">{{ label }}</span>
			<span class="desc">{{ desc }}</span>
		</div>
		<div class="action">
			<open-ssl v-if="status === 2" :username="$config.sslAppid" :path="`${ $config.sslPath }?consultId=${id}`">
				<van-button class="btn" type="primary" size="small" block @click="onClick">进入咨询</van-button>
			</open-ssl>
			<van-button v-else class="btn" type="primary" size="small" block @click="clickNotAt">查看详情</van-button>
		</div>
	</div>
</template>

<script>
export default {
    name: 'homeSubscribeItem',
    props: {
        id: {
            type: String,
            default: ''
        },
        orderId: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        desc: {
            type: String,
            default: ''
        },
        btnText: {
            type: String,
            default: ''
        },
        status: {
            type: Number,
            default: 0
        }
    },
    methods: {
        // 点击未开始
        async clickNotAt () {
            await this.$router.push(`/order/chatDetail/${this.orderId}`)
        },
        onClick () {
            console.log('点击了这里')
            this.$emit('click')
        }
    }
};
</script>

<style scoped lang="less">
@leftLineWidth: 12px;
.home_subscribe_item {
	min-height: 110px;
	border-radius: 16px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	// padding-left: calc(@leftLineWidth + 28px);
	// padding: 28px;
	position: relative;
	overflow: hidden;
	// &::before {
	// 	content: '';
	// 	position: absolute;
	// 	left: 0;
	// 	top: 0;
	// 	height: 100%;
	// 	width: @leftLineWidth;
	// 	background-color: @primary;
	// }
	.content {
		.label {
			font-family: PingFangSC-Semibold;
			font-size: 32px;
			font-weight: normal;
			color: #1f2329;
		}
		.desc {
			// margin-left: 16px;
			font-family: PingFangSC-Regular;
			font-size: 28px;
			font-weight: normal;
			color: #1f2329;
		}
	}
	.action {
		.btn {
			width: 128px;
			height: 58px;
			padding: 0;
			line-height: 58px;
			border-radius: 12px;
		}
	}
}
</style>
